<template>
    <div class="account-completion-skeleton" data-test="account-completion-skeleton">
        <div class="account-completion-skeleton__title" />

        <div class="account-completion-skeleton__progress" />

        <div class="account-completion-skeleton__task-list">
            <div
                v-for="task in 2"
                :key="task"
                class="account-completion-skeleton__task"
            >
                <div class="account-completion-skeleton__task-icon" />
                <div class="account-completion-skeleton__task-text" />
            </div>
        </div>

        <div class="account-completion-skeleton__button" />
    </div>
</template>

<style lang="scss" scoped>
.account-completion-skeleton {
    position: relative;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 12px 16px 20px 16px;
    background-color: color-mix(in srgb, $skeleton-color 40%, transparent);
    border-radius: var(--border-radius, $border-radius);

    @media (min-width: $screen-lg) {
        margin: 0 30px 15px;
    }

    @include skeleton-shimmer {
        display: block;
        z-index: 1;
        pointer-events: none;
    }

    &__title,
    &__progress,
    &__task-icon,
    &__task-text,
    &__button {
        background-color: color-mix(in srgb, $skeleton-color 60%, transparent);
        border-radius: var(--border-radius, $border-radius);
    }

    &__title {
        width: 38%;
        height: math.floor($font-size-sm * $line-height-base);

        @media (min-width: $screen-lg) {
            width: 32%;
            height: math.floor($font-size-lg * $line-height-base);
        }
    }

    &__progress {
        height: 20px;
    }

    &__task-list {
        display: flex;
        flex-direction: column;
        gap: 6px;
    }

    &__task {
        display: flex;
        align-items: center;
        gap: 8px;
    }

    &__task-icon {
        min-width: 20px;
        height: 20px;
        border-radius: 50%;
    }

    &__task-text {
        width: 55%;
        height: 14px;
    }

    &__button {
        height: 44px;
        margin-top: 12px;

        @media (min-width: $screen-md) {
            margin-top: auto;
            width: 140px;
        }
    }
}
</style>
